import { Button } from '@cimpress/react-components';
import { BUTTON_STYLE, BUTTON_GROUP_STYLE } from '../../constants';

interface ActionButtonsProps {
  onSave: () => void;
  onCancel: () => void;
  disabled: boolean;
  saveLabel?: string;
  cancelLabel?: string;
}

/**
 * Reusable action button group component for OK/Cancel operations
 * Used across editable list components (Attributes, Stages, Relationships)
 */
const ActionButtons = ({
  onSave,
  onCancel,
  disabled,
  saveLabel = 'OK',
  cancelLabel = 'Cancel',
}: ActionButtonsProps) => (
  <div style={BUTTON_GROUP_STYLE}>
    <Button
      variant="default"
      onClick={onSave}
      disabled={disabled}
      style={BUTTON_STYLE}
    >
      {saveLabel}
    </Button>
    <Button variant="anchor" onClick={onCancel} style={BUTTON_STYLE}>
      {cancelLabel}
    </Button>
  </div>
);

export default ActionButtons;
